<template>
    <b-modal size="xl" button-size="sm" v-model="showModal" hide-footer @hidden="cancelar" :title="title"
        @hide="resetForm">
        <div v-if="loading" class="overlay">
            <b-spinner label="Carregando..."></b-spinner>
        </div>
        <b-form v-else @submit.prevent="salvarOrcamento">
            <b-row>
                <b-col cols="3">
                    <lg-form-input class="pl-0" label="Núméro:" :disabled="true" v-model="orcamento.numero"
                        description=" " />
                </b-col>
                <b-col cols="3">
                    <LgFormDate class='pl-0' description='' label='Data de Validade:*' v-model="orcamento.dataValidade"
                        :disabled="readonly || (orcamento.numero && !isOrcamentoEmAprovacao && !isOrcamentoEmAndamento)"
                        :state="isValidDate" required @input="validateDate" />

                </b-col>

            </b-row>
            <b-row>

                <b-col cols="6">

                    <LgFinderPagePessoa :prefix="title + ' > '" v-model="orcamento.responsavel" id="finderPagePessoa"
                        label="Responsável:*" :disabled="readonly || isOrcamentoEmAprovacao" />
                </b-col>
                <b-col cols="6">
                    <LgFinderPageUnidadeAdministrativa :prefix="title + ' > '" v-model="orcamento.unidadeAdministrativa"
                        id="finderPageUnidadeAdministrativa" label="Unidade Administrativa:*"
                        :disabled="readonly || isOrcamentoEmAprovacao" />
                </b-col>

            </b-row>
            <b-form-group label-for="Objeto">
                <div class="d-flex align-items-center mb-1">
                    <label for="Objeto" class="mr-2 mb-0">Objeto:</label>
                    <b-button :id="'historicoObjetoOrcamento'" size="sm" variant="primary"
                        @click="mostrarModalConsultarOrcamento" pill>
                        <div>

                            <b-icon icon="clock" />
                        </div>
                    </b-button>
                    <b-tooltip :target="'historicoObjetoOrcamento'" title="Consultar Objetos Semelhantes"></b-tooltip>
                </div>

                <b-form-textarea id="Objeto" v-model="orcamento.objeto" rows="2"
                    :readonly="readonly || isOrcamentoEmAprovacao">
                </b-form-textarea>
            </b-form-group>



            <b-form-group label="Justificativa:" label-for="Justificativa:">
                <b-form-textarea id="justificativa" v-model="orcamento.justificativa" rows="2"
                    :readonly="readonly || isOrcamentoEmAprovacao"></b-form-textarea>
            </b-form-group>

            <b-tabs v-model="activeTab">
                <b-tab v-for="(tipo, index) in tipoOrcamentoEnum" :key="index" :title="'Itens'">
                    <b-row>
                        <b-col class="text-left">
                            <b-button v-if="tipo.id !== 3" size="sm" class='my-3'
                                @click="acessarTabela(tipo.id)">Acessar Tabela {{
                                    tipo.descricao
                                }}</b-button>
                        </b-col>
                        <b-col class="text-right">
                            <b-button id="novo" size="sm" class='my-3' @click="adicionarItem"
                                :disabled="readonly || isOrcamentoEmAprovacao">

                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>

                            </b-button>
                        </b-col>
                    </b-row>
                    <b-table :items="filteredItems(tipo.id)" :fields="itemFields" responsive="sm">
                        <template #head(acoes)>
                            <b-button v-if="filteredItems(tipo.id).length > 0" :id="'adicionarPropostaBtnHeader'"
                                size="sm" variant="info" @click="adicionarPropostaHeader(filteredItems(tipo.id), tipo)"
                                :disabled="readonly || isOrcamentoEmAprovacao">
                                <b-icon icon="file-earmark-plus"></b-icon>
                                <b-tooltip :target="'adicionarPropostaBtnHeader'"
                                    title="Adicionar Proposta"></b-tooltip>
                            </b-button>
                        </template>
                        <template #cell(acoes)="row">
                            <b-button :id="'adicionarPropostaBtn' + row.index" size="sm" variant="info"
                                @click="adicionarProposta(row.item)" :disabled="readonly || isOrcamentoEmAprovacao">
                                <b-icon icon="file-earmark-plus"></b-icon>
                                <b-tooltip :target="'adicionarPropostaBtn' + row.index"
                                    title="Adicionar Proposta"></b-tooltip>
                            </b-button>
                            <b-button :id="'removerItemBtn' + row.index" size="sm" variant="danger" class=""
                                @click="removerItem(row.item)" :disabled="readonly || isOrcamentoEmAprovacao">
                                <b-icon icon="trash"></b-icon>
                                <b-tooltip :target="'removerItemBtn' + row.index" title="Remover Item"></b-tooltip>
                            </b-button>
                        </template>
                        <template #cell(quantidade)="row">

                            <b-form-input style="height: 20px;" v-model.number="row.item.quantidade" type="number"
                                min="0" :readonly="readonly || isOrcamentoEmAprovacao"
                                @change="validateItemQuantity(row.item)"></b-form-input>
                        </template>
                        <template #cell(produto)="row">
                            <b-button v-if="row.item.propostas && row.item.propostas.length > 0" size="sm"
                                variant="primary" class="mr-2" @click="toggleDetails(row.item)">
                                <b-icon :icon="row.item._showDetails ? 'dash' : 'plus'"></b-icon>
                            </b-button>
                            {{ row.item.produto.descricaoResumida }}
                        </template>
                        <template #row-details="row">
                            <b-table :items="row.item.propostas" :fields="propostaFields" responsive="sm">
                                <template #cell(dataValidade)="data">
                                    {{ formatDate(data.item.dataValidade) }}
                                </template>
                                <template #cell(valorItem)="data">
                                    <b-form-input style="height: 20px;" :value="formatCurrency(data.item.valorItem)"
                                        readonly></b-form-input>
                                </template>
                                <template #cell(quantidade)="data">
                                    <b-form-input style="height: 20px;" v-model="data.item.quantidade" type="number"
                                        readonly></b-form-input>
                                </template>
                                <template #cell(acoes)="data">
                                    <b-button id="editarPropostaBtn" size="sm" class='mr-2' variant="warning"
                                        @click="editarProposta(row.item, data.item)" :disabled="readonly">
                                        <b-icon icon="pencil"></b-icon>
                                        <b-tooltip target="editarPropostaBtn" title="Editar Proposta"></b-tooltip>
                                    </b-button>
                                    <b-button id="deletarPropostaBtn" size="sm" variant="danger"
                                        @click="deletarProposta(row.item, data.item)"
                                        :disabled="readonly || isOrcamentoEmAprovacao">
                                        <b-icon icon="trash"></b-icon>
                                        <b-tooltip target="deletarPropostaBtn" title="Deletar Proposta"></b-tooltip>
                                    </b-button>
                                </template>
                            </b-table>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
            <b-form-invalid-feedback v-if="orcamento.itens.length === 0">Adicione ao menos um item ao
                orçamento</b-form-invalid-feedback>
            <div class="d-flex justify-content-center mt-3">
                <b-button id="salvarOrcamento" type="submit" variant="success" style="height: 30px" pill size="sm">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check-circle" />
                    </div>
                    <b-tooltip target="salvarOrcamento" title="Salvar" triggers="hover"></b-tooltip>
                </b-button>
                <b-button id="cancelarOrcamento" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                    <b-tooltip target="cancelarOrcamento" title="Cancelar" triggers="hover"></b-tooltip>
                </b-button>
            </div>
        </b-form>
        <ModalConsultaProdutoCadastroEssencial v-if="showModalConsultaProdutoCadastroEssencial"
            id="finderProdutoRegistroForm" @onselect="handleSelectProduto" invalidFeedback="Informe um produto!"
            :prefix="title" />


        <b-modal id="modal-adicionar-proposta" size="lg" :title="title + ' > Adicionar Proposta'" hide-footer>
            <b-form @submit.prevent="salvarProposta">

                <lg-form-select class="pl-0 pr-0" cols="12" v-model="proposta.tipoPesquisa"
                    :loadFunction="listarTipoPesquisa" labelFormGroupBind="Tipo Pesquisa:*" label="descricao"
                    description="" @input="selecionarTipoPesquisa" />

                <LgFinderPageEmpresa v-if="proposta.tipoPesquisa.id != 3" :prefix='[title]'
                    v-model="proposta.fornecedor" id="finderPageEmpresa" label="Fornecedor:*" cols="12"
                    class="custom-label-font" :disabled="readonly || isOrcamentoEmAprovacao" required />


                <LgFormDate class='pl-0' description='' label='Data de Validade:*' v-model="proposta.dataValidade" />


                <b-form-group v-if="proposta.tipoPesquisa.id == 3" label="Referência:"
                    label-for="proposta-referencia"></b-form-group>
                <b-form-textarea v-if="proposta.tipoPesquisa.id == 3" id="proposta-referencia"
                    v-model="proposta.referencia" rows="3"></b-form-textarea>
                <LgFormDate v-if="proposta.tipoPesquisa.id == 3" class='pl-0' description=''
                    label='Data de Referência:*' v-model="proposta.dataReferencia" />

                <b-table @hidden="cancelarProposta" v-if="propostas && propostas.length > 0" :items="propostas"
                    :fields="ofertaProdutoFields" responsive="sm">

                    <template #cell(quantidade)="data">
                        <b-form-input style="height: 20px;" v-model.number="data.item.quantidade" type="number" min="0"
                            :readonly="isOrcamentoEmAprovacao"></b-form-input>

                    </template>

                    <template #cell(valor)="data">
                        <b-form-input step="0.01" style="height: 20px;" v-model.number="data.item.valor" type="number"
                            min="0" :readonly="isOrcamentoEmAprovacao"></b-form-input>

                    </template>

                    <template #cell(descricao)="data">
                        <b-form-input style="height: 20px;" v-model.number="data.item.descricao" min="0"
                            :readonly="isOrcamentoEmAprovacao"></b-form-input>

                    </template>


                </b-table>

                <b-form-group v-if="!propostas || propostas.length == 0" label="Quantidade:*"
                    label-for="proposta-quantidade">
                    <b-form-input style="height: 20px;" id="proposta-quantidade" v-model.number="proposta.quantidade"
                        type="number" min="0" :readonly="isOrcamentoEmAprovacao"></b-form-input>
                </b-form-group>
                <b-form-group v-if="!propostas || propostas.length == 0" label="Valor Item:*"
                    label-for="proposta-valor-item">
                    <b-form-input style="height: 20px;" id="proposta-valor-item" v-model.number="proposta.valorItem"
                        type="number" step="0.01" min="0" :readonly="isOrcamentoEmAprovacao"></b-form-input>
                </b-form-group>
                <b-form-group v-if="!propostas || propostas.length == 0" label="Descrição da Proposta:"
                    label-for="proposta-descricao">
                    <b-form-textarea id="proposta-descricao" v-model="proposta.descricao" rows="3"
                        :readonly="isOrcamentoEmAprovacao"></b-form-textarea>
                </b-form-group>
                <div class="d-flex justify-content-center mt-3">
                    <b-button id="salvarProposta" type="submit" variant="success" style="height: 30px" pill size="sm">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="check-circle" />
                        </div>
                        <b-tooltip target="salvarProposta" title="Salvar" triggers="hover"></b-tooltip>
                    </b-button>
                    <b-button id="cancelarProposta" class="ml-2" @click="cancelarProposta" style="height: 30px" pill
                        size="sm" variant="danger">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="x-circle" />
                        </div>
                        <b-tooltip target="cancelarProposta" title="Cancelar" triggers="hover"></b-tooltip>
                    </b-button>
                </div>
            </b-form>
        </b-modal>

        <ModalConsultaContratos :objeto="orcamento.objeto" id="ConsultarContratoConsultarOrcamentoForm"
            v-if="showConsultarOrcamento" @close="fecharModalConsultarOrcamento" :prefix="title + ' > '">
        </ModalConsultaContratos>
    </b-modal>
</template>

<script>
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import StatusEnum from "@/core/utils/StatusEnum"
import ModalConsultaProdutoCadastroEssencial from "@/core/components/Modals/ModalConsultaProdutoCadastroEssencial.vue"
import ModalConsultaContratos from "@/core/components/Modals/ModalConsultaContratos.vue"
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue"

export default {
    components: {
        LgFormSelect,
        LgFinderPagePessoa,
        LgFinderPageUnidadeAdministrativa,
        ModalConsultaProdutoCadastroEssencial,
        LgFinderPageEmpresa,
        LgFormDate,
        LgFormInput,
        ModalConsultaContratos
    },
    props: {
        id: {
            type: Number,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            propostas: [],
            tipo: {},
            showConsultarOrcamento: false,
            isOrcamentoEmAndamento: false,
            showModal: true,
            showModalConsultaProdutoCadastroEssencial: false,
            loading: false,
            orcamento: {
                objeto: '',
                dataValidade: '',
                responsavel: {},
                unidadeAdministrativa: {},
                justificativa: '',
                itens: []
            },
            activeTab: 0,
            ofertaProdutoFields: [
                { key: 'produto.produto.descricaoResumida', label: 'Descrição' },
                { key: 'produto.produto.tipoMedida.sigla', label: 'Unidade de Medida' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'valor', label: 'Valor' },
                { key: 'descricao', label: 'Descrição Proposta' },

            ],
            itemFields: [
                { key: 'produto', label: 'Descrição' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'produto.tipoMedida.sigla', label: 'Unidade de Medida' },
                { key: 'precoMedio', label: 'Preço Médio' },
                { key: 'acoes', label: '' }
            ],
            propostaFields: [
                { key: 'dataValidade', label: 'Data de Validade' },
                { key: 'tipoPesquisa.descricao', label: 'Tipo Pesquisa' },
                { key: 'fornecedor.razaoSocial', label: 'Fornecedor' },
                { key: 'valorItem', label: 'Valor Item' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'acoes', label: '' }
            ],
            isValidDate: true,
            tipoOrcamentoEnum: [
                { id: 3, descricao: 'EMPRESA' }
            ],
            proposta: {
                dataReferencia: '',
                referencia: '',
                tipoPesquisa: { id: null, descricao: '' },
                dataValidade: '',
                fornecedor: {},
                representante: '',
                quantidade: 0,
                valorItem: 0,
                descricao: ''
            },
            currentItem: null,
            propostaEditando: null,
            isOrcamentoEmAprovacao: false
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, 'Cadastro']
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    beforeMount() {
        this.$service = new ResourceService('/api/orcamentos')
        this.$serviceProposta = new ResourceService('/api/tipopesquisa');
        this.loadOrcamento();
    },
    methods: {
        adicionarPropostaHeader(produtos, tipo) {
            this.tipo = tipo;
            this.propostas = [];

            produtos.forEach(p =>
                this.propostas.push({ produto: p, quantidade: 1, valor: 0, descricao: '' })
            );
            this.proposta = {
                dataReferencia: '',
                referencia: '',
                tipoPesquisa: { id: null, descricao: "" },
                dataValidade: '',
                fornecedor: '',
                empresa: '',
                representante: '',
                quantidade: null,
                valorItem: null,
                descricao: ''
            }
            this.$bvModal.show('modal-adicionar-proposta')

        },
        async listarTipoPesquisa({ filter, page = 1 }) {
            return this.$serviceProposta.findAll({ filter, page, limit: 5 })
        },
        selecionarTipoPesquisa(tipo) {
            if (tipo.id == 3) {
                this.proposta.fornecedor = {};
            } else {
                this.proposta.dataReferencia = '';
                this.proposta.referencia = '';
            }
            this.proposta.tipoPesquisa = tipo;

        },
        mostrarModalConsultarOrcamento() {
            this.showConsultarOrcamento = true;
        },
        fecharModalConsultarOrcamento() {
            this.showConsultarOrcamento = false;
        },
        OrcamentoEmAprovacao(status) {
            return status === StatusEnum.ORCAMENTO_EM_APROVACAO.value
        },
        OrcamentoEmAndamento(status) {
            return status === StatusEnum.ORCAMENTO_EM_ANDAMENTO.value
        },

        async loadOrcamento() {
            this.loading = true
            if (this.id > 0) {
                const response = await this.$service.findById(this.id)
                this.orcamento = response.data
                this.orcamento.itens = this.orcamento.itens != null ? this.mapItensOrcamento(this.orcamento.itens) : []
                this.isOrcamentoEmAprovacao = this.OrcamentoEmAprovacao(this.orcamento.status.id)
                this.isOrcamentoEmAndamento = this.OrcamentoEmAndamento(this.orcamento.status.id)

            }
            this.loading = false
        },
        mapItensOrcamento(itens) {
            return itens.map(item => {
                const totalPropostas = item.propostas ? item.propostas.length : 0
                const precoMedio = totalPropostas > 0
                    ? (item.propostas.reduce((acc, proposta) => acc + (proposta.quantidade * proposta.valorItem), 0) / totalPropostas).toFixed(2)
                    : 0
                return {
                    ...item,
                    tipoOrcamento: item.tipoOrcamento.id,
                    produto: {
                        ...item.produto,
                        descricaoResumida: item.produto.descricaoResumida,
                        tipoMedida: {
                            sigla: item.produto.tipoMedida.sigla
                        }
                    },
                    quantidade: item.quantidade || 0,
                    precoMedio: `R$ ${parseFloat(precoMedio)}`
                }
            })
        },
        async salvarOrcamento() {
            this.loading = true
            this.validateDate(this.orcamento.dataValidade)
            const currentDate = new Date().setHours(0, 0, 0, 0)
            const validadeDate = new Date(this.orcamento.dataValidade).setHours(0, 0, 0, 0)

            if (!this.isValidDate || validadeDate < currentDate) {
                this.$bvToast.toast('Por favor, insira uma data de validade válida e futura.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                this.loading = false
                return
            }
            if (!this.orcamento.responsavel.id) {
                this.$bvToast.toast('Por favor, selecione um responsável.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                this.loading = false
                return
            }
            if (!this.orcamento.unidadeAdministrativa.id) {
                this.$bvToast.toast('Por favor, selecione uma unidade administrativa.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                this.loading = false
                return
            }
            if (this.orcamento.itens.length === 0) {
                this.$bvToast.toast('Por favor, adicione ao menos um item ao orçamento.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                this.loading = false
                return
            }
            try {

                const orcamentoData = {
                    ...this.orcamento,
                    itens: this.orcamento.itens.map(item => ({
                        ...item,
                        propostas: item.propostas || []
                    }))
                }
                if (this.id) {
                    await this.$service.save({ ...orcamentoData, id: this.id })

                } else {
                    await this.$service.save(orcamentoData)
                }
                this.$bvModal.hide('modal-alterar-orcamento')
                this.$emit("close")
                this.$emit("saved")
            } catch (error) {
                this.$bvToast.toast('Erro ao salvar orçamento. Por favor, tente novamente.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            } finally {
                this.loading = false
            }
        },
        cancelarSalvar() {
            this.showModalConfirmarSalvar = false
        },
        resetForm() {
            this.orcamento = {
                dataValidade: '',
                responsavel: {},
                solicitante: {},
                unidadeAdministrativa: {},
                justificativa: '',
                itens: []
            }
        },
        cancelar() {
            this.$emit("close")
        },
        adicionarItem() {
            this.showModalConsultaProdutoCadastroEssencial = true
        },
        handleSelectProduto(produto) {
            if (produto) {
                const tipoOrcamento = this.tipoOrcamentoEnum[this.activeTab].id
                const itemExistente = this.orcamento.itens.find(
                    (item) => item.produto.id === produto.id && item.tipoOrcamento === tipoOrcamento
                )
                if (!itemExistente) {
                    this.orcamento.itens.push({
                        id: null,
                        tipoOrcamento: tipoOrcamento,
                        produto,
                        quantidade: 1,
                    })
                } else {
                    this.$bvToast.toast('Item já adicionado na lista.', {
                        title: 'Aviso',
                        variant: 'warning',
                        solid: true,
                    })
                }
            }
            this.showModalConsultaProdutoCadastroEssencial = false
        },
        adicionarProposta(item) {
            this.currentItem = item
            this.proposta = {
                dataReferencia: '',
                referencia: '',
                tipoPesquisa: { id: null, descricao: "" },
                dataValidade: '',
                fornecedor: '',
                empresa: '',
                representante: '',
                quantidade: null,
                valorItem: null,
                descricao: ''
            }
            this.$bvModal.show('modal-adicionar-proposta')
        },
        editarProposta(item, proposta) {
            this.currentItem = item;
            this.propostaEditando = proposta;
            this.proposta = { ...proposta };
            this.$bvModal.show('modal-adicionar-proposta')
        },
        salvarProposta() {
            const currentDate = new Date().setHours(0, 0, 0, 0)
            const validadeDate = new Date(this.proposta.dataValidade).setHours(0, 0, 0, 0)

            if (!this.proposta.tipoPesquisa || !this.proposta.tipoPesquisa.id) {
                this.$bvToast.toast('Por favor, escolha um tipo de pesquisa', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                });
                return;

            }

            if (!this.proposta.dataValidade || validadeDate < currentDate) {
                this.$bvToast.toast('Por favor, insira uma data de validade válida e futura.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                });
                return;
            }
            if (this.proposta.tipoPesquisa.id != 3 && (!this.proposta.fornecedor || !this.proposta.fornecedor.razaoSocial)) {
                this.$bvToast.toast('Por favor, selecione um fornecedor.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                });
                return;
            }

            if (this.proposta.tipoPesquisa.id == 3 && (!this.proposta.dataReferencia || this.proposta.dataReferencia == '')) {
                this.$bvToast.toast('Por favor, insira uma data de referência.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                });
                return;
            }

            if (this.proposta.tipoPesquisa.id == 3 && (!this.proposta.referencia || this.proposta.referencia == '')) {
                this.$bvToast.toast('Por favor, digite uma referência.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                });
                return;
            }


            if (this.propostas.length > 0) {

                var mensagemErro = null;

                for (var i = 0; i < this.propostas.length; ++i) {


                    if (!this.propostas[i].quantidade || this.propostas[i].quantidade <= 0) {
                        mensagemErro = 'Por fa(v)or, insira uma quantidade válida.';
                        break;
                    }
                    if (!this.propostas[i].valor || this.propostas[i].valor <= 0) {
                        mensagemErro = 'Por favor, insira um valor de item válido.'
                        break;
                    }


                    if (this.propostas[i].quantidade > this.filteredItems(this.tipo.id)[i].quantidade) {
                        mensagemErro = `A quantidade da proposta não pode ultrapassar a quantidade informada do item.`;
                        break;
                    }


                }

                if (mensagemErro) {
                    this.$bvToast.toast(mensagemErro, {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true
                    });
                    return;

                }

                for (var posicao = 0; posicao < this.propostas.length; ++posicao) {
                    this.proposta.quantidade = this.propostas[posicao].quantidade;
                    this.proposta.valorItem = this.propostas[posicao].valor;
                    this.proposta.descricao = this.propostas[posicao].descricao;

                    this.filteredItems(this.tipo.id)[posicao].propostas = this.filteredItems(this.tipo.id)[posicao].propostas || []
                    this.filteredItems(this.tipo.id)[posicao].propostas.push({ ...this.proposta })
                    this.propostaEditando = null
                    this.$forceUpdate()

                }




            } else {

                if (!this.proposta.quantidade || this.proposta.quantidade <= 0) {
                    this.$bvToast.toast('Por favor, insira uma quantidade válida.', {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                if (!this.proposta.valorItem || this.proposta.valorItem <= 0) {
                    this.$bvToast.toast('Por favor, insira um valor de item válido.', {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }

                if (this.proposta.quantidade > this.currentItem.quantidade) {
                    this.$bvToast.toast(`A quantidade da proposta não pode ultrapassar a quantidade informada do item.`, {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }

                if (this.currentItem) {
                    if (this.propostaEditando) {
                        Object.assign(this.propostaEditando, this.proposta)
                    } else {
                        this.currentItem.propostas = this.currentItem.propostas || []
                        this.currentItem.propostas.push({ ...this.proposta })
                    }
                    this.currentItem = null
                    this.propostaEditando = null
                    this.$forceUpdate()
                }
            }
            this.cancelarProposta();
        },
        cancelarProposta() {
            this.propostas = [];
            this.tipo = {};
            this.$bvModal.hide('modal-adicionar-proposta')
        },
        deletarProposta(item, proposta) {
            const index = item.propostas.indexOf(proposta)
            if (index > -1) {
                item.propostas.splice(index, 1)
                this.$forceUpdate()
                if (item.propostas.length === 0) {
                    this.$set(item, '_showDetails', false)
                }
            }
        },
        removerItem(item) {
            const index = this.orcamento.itens.indexOf(item)
            if (index > -1) {
                this.orcamento.itens.splice(index, 1)
                this.$bvToast.toast('Item removido. A remoção será confirmada após o salvamento do orçamento.', {
                    title: 'Aviso',
                    variant: 'warning',
                    solid: true
                })
                this.$forceUpdate()
            }
        },
        acessarTabela(tipoId) {
            const urls = {
                1: 'https://www.caixa.gov.br/Downloads/sinapi-composicoes-aferidas-sumario-composicoes-aferidas/SUMARIO_DE_PUBLICACOES_E_DOCUMENTACAO_DO_SINAPI.pdf',
                2: 'https://www.gov.br/dnit/pt-br/assuntos/planejamento-e-pesquisa/custos-e-pagamentos/custos-e-pagamentos-dnit/sistemas-de-custos/sicro/relatorios-sicro/relatorios-sicro'
            }
            window.open(urls[tipoId] || '#', '_blank')
        },
        validateDate(event) {
            const date = new Date(event)
            this.isValidDate = !isNaN(date.getTime()) && event !== ''
        },
        filteredItems(tipoId) {
            return this.orcamento.itens.filter(item => item.tipoOrcamento === tipoId)
        },
        toggleDetails(item) {
            this.$set(item, '_showDetails', !item._showDetails)
        },
        formatDate(date) {
            if (!date) return ''
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        formatCurrency(value) {
            if (value == null) return ''
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value))
        },
        validateItemQuantity(item) {
            const totalPropostasQuantidade = item.propostas ? item.propostas.reduce((acc, proposta) => acc + proposta.quantidade, 0) : 0

            if (item.quantidade <= 0) {
                item.quantidade = 1;
            }

            if (item.quantidade < totalPropostasQuantidade) {
                this.$bvToast.toast(`A quantidade do item não pode ser menor do que a soma das quantidades das propostas (${totalPropostasQuantidade}).`, {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                item.quantidade = totalPropostasQuantidade
            }
        }
    }
}
</script>

<style scoped>
.overlay {
    position: fixed;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>